/**
 * Module-level "review owns the keyboard" signal (keymap contract,
 * docs/DECISIONS.md). While a review session is mounted the global ⌘K
 * command palette must be a NO-OP — the hard contract is the due-cards
 * phase, where reveal/rating keys are live, but Escape and U are bound in
 * every phase, so the signal covers the whole mounted session (the same
 * scope the pre-takeover palette used when it no-oped on the /review
 * route). This mirrors, in reverse, how the redesign review suspends its
 * own shortcuts while an edit sheet or swap panel is open
 * (suspendShortcuts in useReviewSession).
 *
 * A tiny mutable singleton rather than store state: ephemeral UI
 * coordination with no persistence, no subscribers and no render impact —
 * the same shape as the review hook's own suspendShortcuts ref, but
 * reachable across chunks (the palette mounts in DataLoader, outside the
 * review route).
 */
export const reviewKeymapSignal = { ownsKeyboard: false };
